import { field, print } from "@/utils/models/decorator-field";
import { model } from "@/utils/models/decorator-model";
import { printBoolean } from "@/utils/pretty-print";
import SizeTableEntry from "./size-table-entry";

@model("SizeTable")
export default class SizeTable {
	@field("number")
	public ID:number = 0;

	@field("string")
	public Name:string = "";

	@field("boolean")
	@print(printBoolean)
	public Active:boolean = true;

	@field("has-many", "SizeTableEntry")
	public Entries:SizeTableEntry[] = [];

	public constructor(data?:any) {
		if (!data) return;
		this.ID = data.ID;
		this.Name = data.Name;
		this.Active = data.Active;
		this.Entries = (data.Entries || []).map((e:any) => new SizeTableEntry(e));
	}

	public getSortedEntries():SizeTableEntry[] {
		return [...this.Entries].sort((a, b) => a.DisplayOrder - b.DisplayOrder);
	}

	public getJSON(this:SizeTable) {
		return {
			ID: this.ID,
			Name: this.Name,
			Active: this.Active,
			Entries: this.Entries.map(e => e.getJSON())
		};
	}
}
